// 3p
import { Router, browserHistory, Route, IndexRoute, Redirect } from 'react-router';
import React, { Component } from 'react';

// Fp
import BaseLayout from './components/layouts/BaseLayout';
import PageLayout from './components/layouts/PageLayout';
import requireLogin from './components/requireLogin';
import Index from './components/pages/Index';
import Show from './components/pages/Show';
import New from './components/pages/New';
import Edit from './components/pages/Edit';

const WideIndex = () => <Index wide={true} />

class App extends Component {
  render() {
    return (
      <Router history={browserHistory}>
        <Redirect from="/" to="/pages" />
        <Route path="pages" component={requireLogin(BaseLayout)}>
          <IndexRoute component={WideIndex} />
          <Route component={PageLayout}>
            <Route path="new" components={{ sidebar: Index, content: New }} />
            <Route path=":pageId" components={{ sidebar: Index, content: Show }} />
            <Route path=":pageId/edit" components={{ sidebar: Index, content: Edit }} />
          </Route>
        </Route>
      </Router>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/Router.js
 **/